import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  useNotify,
} from "react-admin";

export const GroupRoleEdit = (props) => {
  const notify = useNotify();

  return (
    <Edit title="Edit Group Roles" {...props} redirect="list">
      <SimpleForm
        onSuccess={() =>
          notify("Group roles updated successfully", {
            type: "success",
          })
        }
      >
        {/* Group name (read-only) */}
        <TextInput
          source="group_name"
          label="Group"
          disabled
          fullWidth
        />

        {/* Roles */}
        <ReferenceArrayInput
          source="role_id"
          reference="roles"
          label="Roles"
        >
          <AutocompleteArrayInput optionText="name" />
        </ReferenceArrayInput>
      </SimpleForm>
    </Edit>
  );
};